export default "__VITE_ASSET__46465639__"